import Vue from "vue";
import VDialog from "vuetify";
import Vuetify from "vuetify";
import { VHover } from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#333F48",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
      }
    }
  }
};

export default new Vuetify(opts);
